import React from 'react';
import Slider from 'react-slick';

const Values = ({ data, sliderSettings, source }) => {
	//console.log('dataaaaaa',data);
	return source && source === 'home' ? (
		<div className="valeur-content">
			{data &&
				data.map((value, index) => {
					return (
						<div key={index} className="bloc-content col-lg-3 col-md-6 col-sm-12">
							<div className="content">
								<div className="icon">
									{value.images_item?.data?.attributes && (
										<img
											src={`${process.env.GATSBY_API_URL_FILE}` + value.images_item.data.attributes.url}
											alt={value.name}
										/>
									)}
								</div>
								<div className="text">
									<h3>{value.nom}</h3>
									<p>{value.description} </p>
								</div>
							</div>
						</div>
					);
				})}
		</div>
	) : (
		<Slider {...sliderSettings}>
			{data &&
				data.map((value, index) => {
					return (
						<div key={index} className=" col-md-4">
							<div className="icon">
								{value.images_item?.data?.attributes && (
									<img
										src={`${process.env.GATSBY_API_URL_FILE}` + value.images_item.data.attributes.url}
										alt={value.name}
									/>
								)}
							</div>
							<div className="text">
								<h3>{value.nom}</h3>
								<p>{value.description} </p>
							</div>
						</div>
					);
				})}
		</Slider>
	);
};
export default Values;
